<template>
    <div class="form-floating">
        <vue-tags-input
            class="form-control"
            :disabled="disabled"
            v-model="selected"
            :tags="options"
            @tags-changed="update"
            :placeholder="placeholder ?? 'E-mails'"
            @before-adding-tag="checkTag"

        />
        <label class="form-label">{{ label ?? 'E-mails' }}</label>
    </div>
</template>
<script>
import axios from "axios";
import VueTagsInput from '@johmun/vue-tags-input';

export default {
    name: "EmailsSelect",
    props: {
        emails: Array,
        name: String,
        placeholder: String,
        label: String,
        disabled: Boolean,

    },
    components: {
        VueTagsInput
    },

    data() {
        return {
            options: [],
            selected: '',
            autocompleteItems: [],
        }
    },
    watch: {
        emails: function (val) {
            this.update(val)
        },
        options: function (val) {
            this.$emit('input', val)
        },
    },
    methods: {
        update(newTags) {
            this.autocompleteItems = [];
            this.options = newTags;
        },
        checkTag(obj) {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(obj.tag.text)) {
                obj.addTag();
            }
        },
    },
    mounted() {
        this.update(this.emails)
    }
}
</script>

<style scoped>

</style>
